import { gql } from 'graphql-request';
import { useQuery } from '@tanstack/react-query';
import useGraphQLClient from '../../../app/hooks/useGraphQLClient';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import IUserCompany from '../interfaces/IUserCompany';
import useAppLog from '../../../app/features/log/hooks/useAppLog';

const useUserCompanys = () => {
	const auth = useAuthContext();
	const graphQLClient = useGraphQLClient();
	const appLog = useAppLog();

	const { data, isLoading } = useQuery<IUserCompany[] | null, Error>(
		['userCompanys', auth.authAccessToken],
		async () => {
			try {
				const data = (await graphQLClient.request(
					gql`
						query {
							userCompanies {
								id
								name
								middleOfficeId
								group {
									id
									name
									middleOfficeId
								}
							}
						}
					`,
				)) as { userCompanies: IUserCompany[] };

				return data.userCompanies;
			} catch (e) {
				appLog.exception(e, { component: 'useUserCompanys' });
				return null;
			}
		},
		{
			// The query will not execute until the userId exists
			enabled: appLog && auth.isInvestor === true && auth.isAuthenticated,
		},
	);

	return {
		isLoading,
		companies: data,
	};
};

export default useUserCompanys;
